import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import axios from "axios";
import { CheckToken } from "../login/AccessToken";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useHistory, useLocation } from "react-router-dom";

const AppointmentCalender = () => {
  const history = useHistory();
  const { state } = useLocation();
  console.log("State from Appointment Calender page", state);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const [doctorAppointmentList, setDoctorAppointmentList] = useState([]);

  useEffect(() => {
    fetchDoctorAppointmentDetails();
  }, []);

  const handleGoBack = () => {
    const roleType = sessionStorage.getItem("roleType");

    if (roleType === "doctor") {
      history.push("/doctor/appointments", { doctorId: state.id });
    } else if (roleType === "user" || roleType === "facility user") {
      history.push("/doctor/appointments", { doctorId: state.id });
    }
    // You can add a default redirect here if needed
  };
  const subtractTime = (time) => {
    return moment(time).subtract(5, "hours").subtract(30, "minutes").toDate();
  };
  function fetchDoctorAppointmentDetails() {
    const year = state.date.getFullYear();
    const month = String(state.date.getMonth() + 1).padStart(2, "0"); // Adding 1 as months are zero-based
    const day = String(state.date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    const roleType=sessionStorage.getItem("roleType")
    if (Token()) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_doctor_appointments/`,
          {  id: roleType === 'doctor' ? sessionStorage.getItem("doctor_id") : state.id },
          {
            headers: headers,
          }
        )
        .then((response) => {
          setDoctorAppointmentList(response.data.appointments);
        })
        .catch((error) => {
          console.log("FETCH FAILED");
          console.log(error);
        });
    }
  }

  const localizer = momentLocalizer(moment);

  const eventPropGetter = (event, start, end, isSelected) => {
    let color = "DodgerBlue"; // default color

    // Change color based on the event status
    if (event.status === "CANCELLED") {
      color = "red";
    } else if (event.status === "COMPLETED") {
      color = "green";
    }

    return {
      style: {
        backgroundColor: color,
      },
    };
  };

  const mappedAppointments = doctorAppointmentList.map((appointment) => ({
    title: `Patient: ${appointment.patient}`,
    // start: new Date(appointment.start_time),
    // end: new Date(appointment.end_time),
    start: new Date(appointment.start_time_ist), 
    end: new Date(appointment.end_time_ist), 
    status: appointment.status,
    appointment_mode: appointment.appointment_mode,
    new_patient: appointment.new_patient,
  }));

  console.log("MappedAppointments", mappedAppointments);

  return (
    <div>
      <div
        className="back-icon"
        style={{ cursor: "pointer" }}
        onClick={handleGoBack}
      >
        <ArrowBackIcon />
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <li style={{ marginRight: "10px" }}>
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: "DodgerBlue",
                display: "inline-block",
              }}
            ></div>
            <span style={{ marginLeft: "5px" }}>Scheduled</span>
          </li>
          <li style={{ marginRight: "10px" }}>
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: "red",
                display: "inline-block",
              }}
            ></div>
            <span style={{ marginLeft: "5px" }}>Cancelled</span>
          </li>
          <li>
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: "green",
                display: "inline-block",
              }}
            ></div>
            <span style={{ marginLeft: "5px" }}>Completed</span>
          </li>
        </ul>
      </div>

      <Calendar
        localizer={localizer}
        events={mappedAppointments}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        eventPropGetter={eventPropGetter}
      />
    </div>
  );
};

export default AppointmentCalender;
